import { excel, errors } from '@/services/indexnew';

export default {
	namespaced: true,
	state: {
		token: null,
		expire: null,
		nowTime: null,
	},
	mutations: {
		SET_TOKEN(state, token) {
			state.token = token;
		},
		SET_EXPIRE(state, expire) {
			state.expire = expire;
		},
		SET_NOWTIME(state, time) {
			state.nowTime = time;
		},
	},
	actions: {
		async getToken({ state, commit, dispatch }) {
			// 如果已存在token，且当前时间未过30分钟，不进行请求
			let tokenData = null;
			// 时间定死每隔30分钟请求一次，防止本地时间与服务器时间不同步导致重复请求
			const TIMEOUTSTEMP = 1800000;
			// 首先判断当前是否处于无痕模式
			const unIncognito = window.Storage && window.localStorage && window.localStorage instanceof Storage;
			if (unIncognito && sessionStorage.getItem('EXPORT_TOKEN')) {
				const sessionData = JSON.parse(sessionStorage.getItem('EXPORT_TOKEN'));
				if (new Date().getTime() - Number(sessionData.nowTime) < 180000) {
					// 这里是为了和接口返回数据结构一致，方便处理
					tokenData = {
						data: {
							data: { ...sessionData },
						},
						ok: true,
					};
				}
			}
			try {
				const { data, ok } = tokenData ? tokenData : await excel.getToken();
				if (!ok) return;
				const nowTime = data.data.nowTime ? data.data.nowTime : new Date().getTime();
				commit('SET_TOKEN', data.data.token);
				commit('SET_EXPIRE', data.data.expire);
				commit('SET_NOWTIME', nowTime);
				const cache = { ...data.data, nowTime: nowTime };
				// 非无痕模式下，添加缓存
				unIncognito && sessionStorage && sessionStorage.setItem('EXPORT_TOKEN', JSON.stringify(cache));
				// 在这里判断在此请求时间，防止token超时
				let timeout = TIMEOUTSTEMP - (new Date().getTime() - Number(nowTime));
				setTimeout(() => {
					dispatch('getToken');
				}, timeout);
			} catch (error) {
				errors(error);
			}
		},
	},
};
